import React from 'react';

import GenericDebtConsolidationCalculator from '@lendi-jam/debt-consolidation-calculator';
import { embedMarketingTrackingIntoURL } from '@lendi-jam/jam-link';

import { GenericDebtConsolidationCalculatorContent } from '#contentTypes/GenericDebtConsolidationCalculator';

interface PrismicGenericDebtConsolidationCalculatorProps {
  component: GenericDebtConsolidationCalculatorContent;
}

const PrismicGenericDebtConsolidationCalculator: React.FC<PrismicGenericDebtConsolidationCalculatorProps> = ({
  component: { primary },
}) => (
  <GenericDebtConsolidationCalculator
    disclaimer={primary.disclaimer?.text}
    resultHeading={primary.result_heading?.text}
    resultBody={primary.result_body?.text}
    buttonLink={embedMarketingTrackingIntoURL(primary.button_link?.url)}
    buttonText={primary.button_text?.text}
  />
);

export default PrismicGenericDebtConsolidationCalculator;
